export const menuBurger = () => {
    $('.navbar .navbar-toggler').click(function() {
        $(this).toggleClass('active')
        $('.navbar .navbar-container').toggleClass('active')
    })

    $(document).click((e) => {
        if(!$(e.target).closest('.navbar .navbar-toggler').length && !$(e.target).closest('.navbar .navbar-container').length) {
            $('.navbar .navbar-toggler').removeClass('active')
            $('.navbar .navbar-container').removeClass('active')
        }
    })
}

export const menuSubmenu = () => {
    $('.navbar .menu-item-has-children').each(function() {
        const el = $(this),
            elxn = el.find('.menu-expand')

        elxn.click(() => {
            if(el.hasClass('active')) {
                el.removeClass('active')
            } else {
                $('.navbar .menu-item-has-children').removeClass('active')
                el.addClass('active')
            }
        })
    })
}

export const menuSearch = () => {
    $('.navbar .btn-search').click(() => {
        $('.navbar .search-dropdown').addClass('active')
    })

    $(document).click((e) => {
        if (!$(e.target).closest('.navbar .search-dropdown').length && !$(e.target).closest('.navbar .btn-search').length) {
            $('.navbar .search-dropdown').removeClass('active')
        }
    })
}